import React from 'react';

import UtilityBar from '@common/components/app-layout/utility-bar/utility-bar';

import { useGetUserInfo } from '@common/hooks/use-get-user-info';

import UtilityHeaderHelpMenu from './utility-bar-help-menu';

const AwareUtilityBar = () => {
  const { username } = useGetUserInfo();

  return (
    <UtilityBar
      applicationName="Aware"
      secondaryUserInfo={username}
      UtilityHeaderHelpMenu={UtilityHeaderHelpMenu}
    />
  );
};

export default AwareUtilityBar;
